import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { toast } from 'react-toastify';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { contactUsAPIRequest } from '../api';
import { TContactUsDTO } from '../types';
import { endTask, onSuccess, startTask } from './layout-slice';

type TAction = {
  type: string;
  payload: TContactUsDTO;
};

export function* contactUsSaga({ payload }: TAction): SagaIterator {
  try {
    yield put(startTask());
    yield call(contactUsAPIRequest, payload);
    yield call(toast, "Request received we'll contact you soon.", {
      type: 'success',
      position: 'bottom-center',
    });
    yield put(onSuccess());
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield call(toast, errorMsg, {
      type: 'error',
      position: 'bottom-center',
    });
  } finally {
    yield put(endTask());
  }
}
